import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const MetaTags = ({ page = 'home' }) => {
  const { t, i18n } = useTranslation('seo');
  const currentLang = i18n.language;
  const location = useLocation();

  // Construct canonical URL by combining base URL with current pathname (no query params)
  const baseUrl = 'https://www.matcha-game.com';
  const canonicalUrl = `${baseUrl}${location.pathname}`;

  return (
    <Helmet>
      {/* HTML lang attribute - critical for SEO */}
      <html lang={currentLang} />

      {/* Title */}
      <title>{t(`${page}.title`)}</title>

      {/* Meta Description */}
      <meta name="description" content={t(`${page}.description`)} />

      {/* Keywords - especially important for Korean SEO */}
      <meta name="keywords" content={t(`keywords.${currentLang}`)} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={t(`${page}.title`)} />
      <meta property="og:description" content={t(`${page}.description`)} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.matcha-game.com" />
      <meta property="og:image" content="https://www.matcha-game.com/social-share.jpg" />

      {/* Korean-specific Open Graph */}
      {currentLang === 'ko' && (
        <meta property="og:locale" content="ko_KR" />
      )}
      {currentLang === 'en' && (
        <meta property="og:locale" content="en_US" />
      )}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t(`${page}.title`)} />
      <meta name="twitter:description" content={t(`${page}.description`)} />
      <meta name="twitter:image" content="https://www.matcha-game.com/social-share.jpg" />

      {/* Naver-specific meta tag for Korean users (Naver is Korea's #1 search engine) */}
      {currentLang === 'ko' && (
        <>
          <meta name="naver-site-verification" content="verification-code-placeholder" />
          <meta property="article:author" content="Savage" />
        </>
      )}

      {/* hreflang tags -告訴搜索引擎語言版本 */}
      <link rel="alternate" hrefLang="en" href="https://www.matcha-game.com/" />
      <link rel="alternate" hrefLang="ko" href="https://www.matcha-game.com/" />
      <link rel="alternate" hrefLang="x-default" href="https://www.matcha-game.com/" />

      {/* Canonical URL - dynamically generated to strip query parameters */}
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default MetaTags;
